import Swiper from "swiper11";
import { Navigation, Pagination, Thumbs } from "swiper11/modules";
import gsap from "gsap";
import { createdThumbs } from "../utils/utils";
interface SwiperWithT extends Swiper {
  T: (type: string, target: JQuery<HTMLElement>, next?: () => void) => Promise<void>;
}
const Case = () => {
  const pageMarker = $("._Case_");
  if (!pageMarker.length) return;

  new Swiper(pageMarker.find(".case-brand .swiper-box .swiper")[0], {
    modules: [Pagination, Thumbs, Navigation],
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 60,
    speed: 850,
    slideToClickedSlide: true,
    pagination: {
      el: ".case-brand .custom-swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      prevEl: ".case-brand .prev",
      nextEl: ".case-brand .next",
    },
    on: {
      init(swiper) {
        const T = (type: string, target: JQuery<HTMLElement>, next?: () => void) => {
          const isPrev = type === "prev";
          const animateButton = {
            autoAlpha: 0,
            y: isPrev ? 20 : 20,
          };
          const animateTitle = {
            autoAlpha: 0,
            y: isPrev ? -20 : -20,
          };
          const animatePoint = {
            "--pointPostion": isPrev ? "0%" : "100%",
          };
          return new Promise<void>((resolve) => {
            const timeline = gsap.timeline({
              onComplete: () => {
                next?.();
                gsap.set(target.find(".title"), { clearProps: "all" });
                gsap.set(target.find(".case-btn"), { clearProps: "all" });
                resolve();
              },
            });
            timeline[isPrev ? "to" : "from"](target.find(".title"), animateTitle, 0);
            timeline.to(target.find(".point"), animatePoint, 0);
            timeline[isPrev ? "to" : "from"](target.find(".case-btn"), animateButton, 0);
          });
        };
        Object.assign(swiper, { T });
      },
      slideChangeTransitionStart: async (swiper) => {
        const swiperWithT = swiper as SwiperWithT;
        swiperWithT.allowTouchMove = false;
        const prev = $(swiperWithT.slides[swiperWithT.previousIndex]).find("> a");
        const next = $(swiperWithT.slides[swiperWithT.activeIndex]).find("> a");
        await swiperWithT.T("prev", $($(prev).attr("data-target") as string));
        next.tab("show");
        await swiperWithT.T("next", $($(next).attr("data-target") as string));
        swiperWithT.allowTouchMove = true;
      },
    },
  });

  new Swiper(pageMarker.find(".case-marketing .swiper-box.main .swiper")[0], {
    modules: [Thumbs],
    loop: true,
    slidesPerView: 1,
    speed: 850,
    spaceBetween: 60,
    on: {
      beforeInit: (swiper) => {
        createdThumbs(swiper, ".case-marketing .swiper-box.thumb .swiper", {
          cloneTarget: ".navTitle",
          swiperOptions: {
            slidesPerView: "auto",
          },
        });
      },
    },
  });
};

export default Case;
